import { JSX } from 'react'

import { Breadcrumb } from '@chakra-ui/react'




// eslint-disable-next-line @typescript-eslint/naming-convention
export function Item
(
	props: {
		name: string
		last: boolean

	},

)
:	JSX.Element
{
	if (props.last)
	{
		return (
			<Breadcrumb.Item>
				<Breadcrumb.CurrentLink whiteSpace="nowrap">{props.name}</Breadcrumb.CurrentLink>

			</Breadcrumb.Item>

		)

	}

	return (
		<>
			<Breadcrumb.Item>
				<Breadcrumb.Link whiteSpace="nowrap">{props.name}</Breadcrumb.Link>
			</Breadcrumb.Item>

			<Breadcrumb.Separator />

		</>

	)

}


// eslint-disable-next-line @typescript-eslint/naming-convention
export function Root
(
	props: {
		value: string[]

	},

)
:	JSX.Element
{
	let items = props.value
		.map(
			(v, i) => <Item key={i} name={v} last={i >= props.value.length - 1} />,

		)

	return (
		<Breadcrumb.Root>
			<Breadcrumb.List>{items.flat()}</Breadcrumb.List>

		</Breadcrumb.Root>

	)

}
